import Vue from 'vue'
import axios from 'axios';
import qs from 'qs'
import router from '../main.js'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

axios.defaults.baseURL = 'https://mr.summary88.com/';

axios.interceptors.request.use((config) => {
	let token = Vue.prototype.getCookie('token');
	if(token && token != undefined && token != 'undefined') {
		config.headers['token'] = token;
	}
	return config;
}, (error) => {
	return Promise.reject(error);
});

axios.interceptors.response.use(
	response => {
		if(response.data.code == '-1') {
			layui.use('layer', () => {
				var layer = layui.layer;
				layer.closeAll();
				layer.msg('登录已过期，请重新登录', {
					icon: 2,
					anim: 6
				})
			})
			setTimeout(function() {
				router.replace('login')
			}, 1500)
		}
		return response;
	},
	error => {

	}
);

export default {
	// 获取验证码
	getCodes(params) {
		let url = 'api/Company/getCode'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 企业注册
	register(params) {
		let url = 'api/Company/register'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 忘记密码
	forgetPwd(params) {
		let url = 'api/Company/forgetPwd'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 完善用户信息
	fillInfo(params) {
		let url = 'api/Company/fillInfo'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取用户信息
	getMemberInfo(params) {
		let url = 'api/Company/getMemberInfo'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取规格信息
	getAttrs(params) {
		let url = '/api/Mesh/mesh_norm_category'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取 钢网制作规范 
	attr(params) {
		let url = '/api/Mesh/attr'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 登录
	userLogin(params) {
		let url = 'api/Company/login'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 会员中心-首充和续充设置接口接口
	recharge(params) {
		let url = 'api/Recharge/recharge_setting_first'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 会员中心-创建充值订单
	rechargeOrder(params) {
		let url = 'api/Recharge/createOrder'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 企业端-充值支付回调
	pay(params) {
		let url = 'api/Recharge/pay'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 企业端-验证支付
	returnx(params) {
		let url = 'api/Recharge/pay_status'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 修改密码
	editPwd(params) {
		let url = 'api/Company/editPwd'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 积分明细
	getScoreLog(params) {
		let url = 'api/Company/getScoreLog'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  获取用户地址列表
	getAddressList(params) {
		let url = 'api/Company/getAddressList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  新增用户地址列表
	addAddress(params) {
		let url = 'api/Company/addAddress'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  编辑用户地址列表
	editAddress(params) {
		let url = 'api/Company/editAddress'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  删除用户地址列表
	delAddress(params) {
		let url = 'api/Company/delAddress'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  设置默认地址
	setDefaultAddress(params) {
		let url = 'api/Company/setDefaultAddress'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  获取联系人列表
	getContactList(params) {
		let url = 'api/Company/getContactList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  新增联系人
	addContact(params) {
		let url = 'api/Company/addContact'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  编辑联系人
	editContact(params) {
		let url = 'api/Company/editContact'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  删除联系人
	delContact(params) {
		let url = 'api/Company/delContact'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  设置默认联系人
	setDefaultContact(params) {
		let url = 'api/Company/setDefaultContact'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 发票明细
	getInvoiceLog(params) {
		let url = 'api/Company/getInvoiceLog'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 新增发票
	addInvoice(params) {
		let url = 'api/Company/addInvoice'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取我的订单
	OrderList(params) {
		let url = 'api/Order/cOrderList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 创建订单
	createOrder(params) {
		let url = 'api/Order/createOrder'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取订单详情
	getOrderDetail(params) {
		let url = 'api/Order/getOrderDetail'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 快递信息详情
	expressDetail(params) {
		let url = 'api/Express/express_detail'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 快递运费详情
	cityFreight(params) {
		let url = 'api/Express/city_freight'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 取消订单
	cancelOrder(params) {
		let url = 'api/Order/cancelOrder'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 企业端-支付订单
	payOrder(params) {
		let url = 'api/Order/payOrder'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 企业端-确认工程文件
	confirmFile(params) {
		let url = 'api/Order/confirmFile'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 企业端-提交售后
	postSale(params) {
		let url = 'api/Order/postSale'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 企业端-完成订单
	finishOrder(params) {
		let url = 'api/Order/finishOrder'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 企业端-订单超时
	overtimeOrder(params) {
		let url = 'api/Order/overtimeOrder'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 加入购物车
	addShopCar(params) {
		let url = 'api/ShopCar/addShopCar'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取购物车列表
	getShopCarList(params) {
		let url = 'api/ShopCar/getShopCarList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//查看购物车商品
	getShopCarDetail(params) {
		let url = 'api/ShopCar/getShopCarDetail'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 删除购物车商品
	delShopCar(params) {
		let url = 'api/ShopCar/delShopCar'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 编辑购物车商品
	editShopCar(params) {
		let url = 'api/ShopCar/editShopCar'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 结算购物车
	createShopCarOrder(params) {
		let url = 'api/ShopCar/createOrder'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 支付尾款
	payAddPrice(params) {
		let url = 'api/Order/payAddPrice'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 企业确认订单所有文件无误
	confirmOrder(params) {
		let url = 'api/Order/confirmOrder'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  获取售后问题分类
	getSaleCateGory(params) {
		let url = 'api/Order/getSaleCateGory'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 发起售后
	postSale(params) {
		let url = 'api/Order/postSale'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 添加订单评价
	addOrderEvaluate(params) {
		let url = 'api/Order/addOrderEvaluate'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取新消息状态
	getNewMsgStatus(params) {
		let url = 'api/Chat/getNewMsgStatus'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取消息列表
	getMsgList(params) {
		let url = 'api/Chat/getMsgList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 发送新消息
	sendMsg(params) {
		let url = 'api/Chat/sendMsg'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取新消息状态-全局
	getAllMsgStatus(params) {
		let url = 'api/Chat/getAllMsgStatus'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 新增子账号
	addSubAccount(params) {
		let url = 'api/Company/addSubAccount'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取子账号列表
	getSubAccountList(params) {
		let url = 'api/Company/getSubAccountList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 冻结子账号
	closeSubAccount(params) {
		let url = 'api/Company/closeSubAccount'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 启用子账号
	openSubAccount(params) {
		let url = 'api/Company/openSubAccount'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 删除子账号
	delSubAccount(params) {
		let url = 'api/Company/delSubAccount'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 获取订单时间轴
	getOrderProgress(params) {
		let url = 'api/Order/getOrderProgress'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//获取充值文案
	copywriting(params) {
		let url = 'api/Index/copywriting'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//顺丰速运发货轨迹查询
	shunfeng(params) {
		let url = 'api/Express/f_query_express'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//德邦物流发货轨迹查询
	debang(params) {
		let url = 'api/Express/gj_express'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//京广物流发货轨迹查询
	jg_query(params) {
		let url = 'api/Express/jg_query'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//信丰物流发货轨迹查询
	xf_query(params) {
		let url = 'api/Express/xf_query'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//京东物流发货轨迹查询
	jd_query(params) {
		let url = 'api/Express/jd_query'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//站内公告
	notice(params) {
		let url = '/api/Index/notice'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 工程师服务条款》》》》3个端的服务条款
	gcsSecrecy(params) {
		let url = '/api/Index/gcs_secrecy'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 企业服务条款》》》》3个端的保密协议
	qySecrecy(params) {
		let url = '/api/Index/qy_secrecy'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 等级说明
	memberLevel(params) {
		let url = '/api/Index/member_level'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 桃琼之瑶标准说明
	requirement(params) {
		let url = '/api/Index/requirement'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 充值记录
	record(params) {
		let url = '/api/Recharge/recharge_record'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 再来一单
	copyOrderInfo(params) {
		let url = '/api/order/copyOrderInfo'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 钢网厚度
	getMeshAttrInfo(params) {
		let url = '/api/Mesh/getMeshAttrInfo'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 导出订单列表
	exportOrderList(params) {
		let url = '/api/Order/exportOrderList'
		return axios.post(url, qs.stringify(params),{responseType:"blob"}).then(res => res.data);
	},
	// 现金支付二维码
	getPayQrcode(params) {
		let url = '/api/Order/getPayQrcode'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 验证支付状态
	checkPayStatus(params) {
		let url = '/api/Order/checkPayStatus'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 月结订单列表
	cMonthOrderList(params) {
		let url = '/api/Order/cMonthOrderList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	// 现金支付
	getOrderPay(params) {
		let url = '/api/Order/pay'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  获取常见问题分类
	getQuestionCategory(params) {
		let url = '/api/Question/getQuestionCategory'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  获取常见问题列表
	getQuestionList(params) {
		let url = '/api/Question/getQuestionList'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
	//  获取常见问题详情
	getQuestionDetail(params) {
		let url = '/api/Question/getQuestionDetail'
		return axios.post(url, qs.stringify(params)).then(res => res.data);
	},
}


// WEBPACK FOOTER //
// ./src/utils/api.js